import { render, staticRenderFns } from "./PublishWeb.vue?vue&type=template&id=2b06f748&scoped=true&"
import script from "./PublishWeb.vue?vue&type=script&lang=js&"
export * from "./PublishWeb.vue?vue&type=script&lang=js&"
import style0 from "./PublishWeb.vue?vue&type=style&index=0&id=2b06f748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b06f748",
  null
  
)

export default component.exports